import { confetti } from "@tsparticles/confetti";

function allTheAdam() {
    const now = new Date();
    const isAprilFools =
        now.getDate() === 1 && now.getMonth() === 3; /* months start at 0 */
    if (!isAprilFools || import.meta.env.VITE_APP_ENV !== "local") {
        return;
    }

    const end = Date.now() + 0.5 * 1000;
    (function frame() {
        confetti({
            particleCount: 2,
            angle: 60,
            spread: 55,
            origin: { x: 0 },
            scalar: 10,
            shapes: "images",
            shapeOptions: {
                images: {
                    src: "https://stur.ge/images/face1.webp",
                },
            },
        });

        confetti({
            particleCount: 2,
            angle: 120,
            spread: 55,
            origin: { x: 1 },
            scalar: 10,
            shapes: "images",
            shapeOptions: {
                images: {
                    src: "https://stur.ge/images/face1.webp",
                },
            },
        });

        if (Date.now() < end) {
            requestAnimationFrame(frame);
        }
    })();
}

function weAreStawberry() {
    const ascii = `
 ____  _                      _
/ ___|| |_ _ __ __ ___      _| |__   ___ _ __ _ __ _   _   _ __ ___   ___
\\___ \\| __| '__/ _\` \\ \\ /\\ / / '_ \\ / _ \\ '__| '__| | | | | '_ \` _ \\ / _ \\
 ___) | |_| | | (_| |\\ V  V /| |_) |  __/ |  | |  | |_| |_| | | | | |  __/
|____/ \\__|_|  \\__,_| \\_/\\_/ |_.__/ \\___|_|  |_|   \\__, (_)_| |_| |_|\\___|
                                                   |___/
`;

    console.info(ascii);
}

function playFun() {
    weAreStawberry();
    allTheAdam();
}

playFun();
